import React from 'react'
import { type IconProps } from '../IconPropsInterface'

export const ChevronDownLarge: React.FC<IconProps> = ({
  color,
  size,
  fill,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 8L11.5 15.5L19 8"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
